import styled from "styled-components";

export const CalculadorasSelectContainer = styled.div`
  .calculadoras {
    display: grid;
    row-gap: 16px;
    column-gap: 16px;
    grid-template-columns: repeat(3, 1fr);
  }

  .ant-divider {
    margin: 48px 0 24px;
    border-top: 2px solid var(--velotax-background-color);
  }

  .MuiButtonBase-root {
    border-radius: 8px;
  }

  .ant-checkbox-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin: 0;
    padding: 8px;
    width: 160px;
    height: 160px;
    border-radius: 8px;
    background-color: var(--velotax-background-color);
    border: 2px solid var(--velotax-background-color);

    &.ant-checkbox-wrapper-checked {
      border: 2px solid var(--ant-primary-color);
    }

    .ant-checkbox-checked:after {
      border-radius: 20px;
    }

    .ant-checkbox {
      position: absolute;
      right: 12px;
      top: 12px;
      display: flex;
      justify-content: flex-end;
    }

    .checkbox-wrapper {
      display: flex;
      align-items: center;
      row-gap: 16px;
      flex-direction: column;

      svg {
        width: 56px;
        height: 56px;
        fill: var(--ant-primary-color);
      }

      .label {
        font-weight: 600;
        font-size: 0.875rem;
        line-height: 1.25rem;
        text-align: center;
        color: var(--velotax-font-color-light);
      }
    }

    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: var(--velotax-background-color);
    }

    .ant-checkbox-inner {
      border: none;
      width: 20px;
      height: 20px;
      border-radius: 20px;
      background: var(--velotax-background-color);
    }

    :hover .ant-checkbox:after {
      visibility: hidden;
    }

    .ant-checkbox-inner:after {
      top: 9px;
      left: 6px;
      border-color: var(--ant-primary-color);
    }
  }

  @media only screen and (max-device-width: 812px) {
    .calculadoras {
      grid-template-columns: repeat(2, 1fr);
    }
    .ant-checkbox-wrapper {
      width: 100%;
    }
  }
`;
